import { AlarmGroupContainer } from '@hakimo-ui/hakimo/feature-shared';
import {
  CamAction,
  EscalationState,
  UnifiedAlarmGroup,
  UnifiedMonitoringProduct,
} from '@hakimo-ui/hakimo/types';
import { FullViewModal } from '@hakimo-ui/shared/ui-base';

interface Props {
  alarmGroup: UnifiedAlarmGroup;
  onClose: () => void;
  handleCamAction: (actionType: CamAction) => (comment?: string) => void;
  onCreateEscalation: (comment?: string) => void;
  escalationState?: EscalationState;
  onResolveEscalation: (comment?: string) => void;
}

export function InvestigateViewModal(props: Props) {
  const {
    onClose,
    alarmGroup,
    handleCamAction,
    onCreateEscalation,
    onResolveEscalation,
    escalationState,
  } = props;

  return (
    <FullViewModal open={true} onClose={onClose} title="Investigation View">
      <AlarmGroupContainer
        alarmGroup={alarmGroup}
        product={alarmGroup.product ?? UnifiedMonitoringProduct.SCAN}
        escalationState={escalationState}
        onResolveEscalation={onResolveEscalation}
        onCreateEscalation={onCreateEscalation}
        handleCamAction={handleCamAction}
        onCloseInvestigateModal={onClose}
      />
    </FullViewModal>
  );
}

export default InvestigateViewModal;
